import React, { FC } from 'react';

import { IProductCardTitle } from './model';

const ProductCardTitle: FC<IProductCardTitle> = ({ title }): React.ReactElement => <>{title}</>;

export default ProductCardTitle;
